import { savedListTypes } from '../utils';

export const createList = (axiosInstance, listName, listType, playerSchoolId) => {
    const url = playerSchoolId ? `v2/saved` : `v1/saved`;
    let postParams = {
        name: listName,
        type: listType === 'players' ? 'Player' : 'School',
    };
    // if we need to create list and players in a single api call
    if (playerSchoolId) {
        postParams = {
            ...postParams,
            listId: 0,
            playerOrSchoolIds: playerSchoolId,
        };
    }
    return axiosInstance.post(url, postParams);
};

export const getAllLists = (axiosInstance) => {
    const url = `v1/saved`;
    return axiosInstance.get(url);
};

export const checkIfListExists = (axiosInstance, listName, listType) => {
    const url = `v1/saved/exists`;
    const postParams = {
        name: listName,
        type: listType === 'players' ? 'Player' : 'School',
    };
    return axiosInstance.post(url, postParams);
};

export const deleteList = (axiosInstance, listId) => {
    const url = `v1/saved/${listId}`;
    return axiosInstance.delete(url);
};

export const updateListName = (axiosInstance, listId, listname) => {
    const url = `v1/saved/${listId}/updatelistname`;
    const postParams = {
        name: listname,
    };
    return axiosInstance.post(url, postParams);
};

export const addPlayerToList = (axiosInstance, playerId, listId) => {
    const url = `v1/saved/addplayertolist`;
    const postParams = {
        playerId,
        listId,
    };
    return axiosInstance.post(url, postParams);
};

export const removePlayerFromList = (axiosInstance, playerId, listId) => {
    const url = `v1/saved/removeplayerfromlist`;
    const postParams = {
        playerId,
        listId,
    };
    return axiosInstance.post(url, postParams);
};

export const addSchoolToList = (axiosInstance, schoolClubId, listId) => {
    const url = `v1/saved/addschooltolist`;
    const postParams = {
        schoolClubId,
        listId,
    };
    return axiosInstance.post(url, postParams);
};

export const removeSchoolFromList = (axiosInstance, schoolClubId, listId) => {
    const url = `v1/saved/removeschoolfromlist`;
    const postParams = {
        schoolClubId,
        listId,
    };
    return axiosInstance.post(url, postParams);
};

export const updateItemNotes = (axiosInstance, savedId, notes, listType) => {
    let url = '';
    if (listType === savedListTypes.players.key) {
        url = `v1/saved/${savedId}/updateplayernotes`;
    } else {
        url = `v1/saved/${savedId}/updateschoolnotes`;
    }
    const postParams = {
        notes,
    };
    return axiosInstance.post(url, postParams);
};

export const getSavedPlayerAndLists = (axiosInstance, playerId) => {
    const url = `v1/saved/getplayerandlists`;
    return axiosInstance.get(url, {
        params: {
            playerId,
        },
    });
};

export const getSavedSchoolsAndLists = (axiosInstance, schoolClubId) => {
    const url = `v1/saved/getschoolandlists`;
    return axiosInstance.get(url, {
        params: {
            schoolClubId,
        },
    });
};

export const createPlayerWithLists = (axiosInstance, listIds, playerId) => {
    const url = `v1/saved/createplayerwithlists`;
    const postParams = {
        listIds,
        playerId,
    };
    return axiosInstance.post(url, postParams);
};

export const updatePlayerLists = (axiosInstance, listIds, savedId) => {
    const url = `v1/saved/${savedId}/updateplayerlists`;
    const postParams = {
        listIds,
    };
    return axiosInstance.post(url, postParams);
};

export const createSchoolWithLists = (axiosInstance, listIds, schoolClubId) => {
    const url = `v1/saved/createschoolwithlists`;
    const postParams = {
        listIds,
        schoolClubId,
    };
    return axiosInstance.post(url, postParams);
};

export const updateSchoolLists = (axiosInstance, listIds, savedId) => {
    const url = `v1/saved/${savedId}/updateschoollists`;
    const postParams = {
        listIds,
    };
    return axiosInstance.post(url, postParams);
};
